import { FC, memo, ReactNode } from "react";

type Props = {
  children: ReactNode;
  onClick: () => void;
};

export const PrimaryButton: FC<Props> = memo((props) => {
  const { children, onClick } = props;
  return (
    <button
      type="submit"
      className="bg-geexgreen-200 hover:bg-geexgreen-100 text-white rounded px-4 py-2"
      onClick={onClick}
    >
      {children}
    </button>
  );
});
